import { render, staticRenderFns } from "./MsgEmail.vue?vue&type=template&id=23b9f731"
import script from "./MsgEmail.vue?vue&type=script&lang=js"
export * from "./MsgEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports